<div class="p-6">

  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-xl font-semibold">Weryfikacja NIP</h2>
      <p class="text-secondary text-sm mt-1">Użytkownicy z NIP-em zawierającym litery, myślniki, spacje lub inne znaki</p>
    </div>
    <div class="flex items-center gap-3">
      <button mat-stroked-button (click)="loadInvalidNips()" [disabled]="isLoading">
        <mat-icon [svgIcon]="'tabler_outline:refresh'"></mat-icon>
        Odśwież
      </button>
      <button mat-flat-button color="primary" 
        (click)="cleanAllNips()" 
        [disabled]="isLoading || isCleaningAll || remainingToClean === 0">
        <mat-icon [svgIcon]="'tabler_outline:sparkles'"></mat-icon>
        Wyczyść wszystkie ({{ remainingToClean }})
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex justify-center py-12">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && users.length === 0" class="text-center py-12">
    <mat-icon [svgIcon]="'tabler_outline:circle-check'" class="text-green-500 !w-12 !h-12 mb-4"></mat-icon>
    <h3 class="text-lg font-medium">Wszystkie NIP-y są prawidłowe</h3>
    <p class="text-secondary mt-1">Brak użytkowników z nieprawidłowym formatem NIP.</p>
  </div>

  <!-- Summary -->
  <div *ngIf="!isLoading && users.length > 0" class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
    <div class="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-4 text-center">
      <div class="text-2xl font-bold">{{ totalCount }}</div>
      <div class="text-sm text-secondary">Nieprawidłowych NIP</div>
    </div>
    <div class="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 text-center">
      <div class="text-2xl font-bold text-blue-600">{{ canAutoCleanCount }}</div>
      <div class="text-sm text-secondary">Można wyczyścić automatycznie</div>
    </div>
    <div class="bg-orange-50 dark:bg-orange-900/20 rounded-xl p-4 text-center">
      <div class="text-2xl font-bold text-orange-600">{{ cannotAutoCleanCount }}</div>
      <div class="text-sm text-secondary">Wymaga ręcznej weryfikacji</div>
    </div>
    <div class="bg-green-50 dark:bg-green-900/20 rounded-xl p-4 text-center">
      <div class="text-2xl font-bold text-green-600">{{ cleanedCount }}</div>
      <div class="text-sm text-secondary">Wyczyszczonych</div>
    </div>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading && users.length > 0" class="overflow-x-auto">
    <table class="w-full text-sm">
      <thead>
        <tr class="border-b border-gray-200 dark:border-gray-700">
          <th class="text-left py-3 px-4 font-medium text-secondary">Email</th>
          <th class="text-left py-3 px-4 font-medium text-secondary">Firma</th>
          <th class="text-left py-3 px-4 font-medium text-secondary">Obecny NIP</th>
          <th class="text-left py-3 px-4 font-medium text-secondary">Po wyczyszczeniu</th>
          <th class="text-right py-3 px-4 font-medium text-secondary">Akcja</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users" 
          class="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900/30 transition-colors"
          [ngClass]="{ 'opacity-50': user.isCleaned }">
          <td class="py-3 px-4">
            <span class="text-xs text-gray-500">{{ user.email }}</span>
          </td>
          <td class="py-3 px-4">{{ user.companyName || '—' }}</td>
          <td class="py-3 px-4">
            <code class="px-2 py-1 rounded text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 text-xs"
              [ngClass]="{ 'line-through': user.isCleaned }">
              {{ user.currentNip }}
            </code>
          </td>
          <td class="py-3 px-4">
            <code *ngIf="user.canAutoClean" 
              class="px-2 py-1 rounded text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20 text-xs">
              {{ user.cleanedNip }}
            </code>
            <span *ngIf="!user.canAutoClean" 
              class="text-orange-600 dark:text-orange-400 text-xs font-medium"
              [matTooltip]="'Po usunięciu znaków NIP nie ma 10 cyfr'">
              Nie można wyczyścić automatycznie
            </span>
          </td>
          <td class="py-3 px-4 text-right">
            <button *ngIf="user.canAutoClean && !user.isCleaned" 
              mat-stroked-button
              color="primary"
              [disabled]="user.isCleaningInProgress"
              (click)="cleanNip(user)"
              class="!text-xs !py-1 !px-3 !min-h-[32px]">
              <mat-spinner *ngIf="user.isCleaningInProgress" [diameter]="16" class="mr-1"></mat-spinner>
              <mat-icon *ngIf="!user.isCleaningInProgress" [svgIcon]="'tabler_outline:eraser'" class="!w-4 !h-4 mr-1"></mat-icon>
              Wyczyść
            </button>
            <span *ngIf="user.isCleaned" class="text-green-600 dark:text-green-400 text-xs font-medium flex items-center justify-end gap-1">
              <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4"></mat-icon>
              Wyczyszczony
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
